import React from "react";
import IDataResponse from "./IDataResponse";

const DataCtx: React.Context<IDataResponse> = React.createContext(undefined as any as IDataResponse);

export default DataCtx;